import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const TeamPreview = (props) => {
    const { team, style, active, onClick } = props;
    const id = Math.random().toString();
    return team ? (React.createElement(TeamPreviewStyled, { style: style, active: active, onClick: onClick }, team.name)) : (React.createElement("p", null));
};
export default TeamPreview;
const size = 27;
const TeamPreviewStyled = styled.div `
  padding: 0px 10px;
  height: ${size}px;
  display: inline-block;
  text-align: center;
  border-radius: 15px;
  line-height: 27px;
  color: ${THEME.COLOR_SECONDARY};
  font-size: 11px;
  margin-right: 5px;
  background-color: ${THEME.NEUTRAL};
  position: relative;
  user-select: none;

  ${(props) => props.active
    ? `
      &::before {
        content: ' ';
        border: 2px solid ${THEME.COLOR_ACCENT};
        width: calc(100% + 8px);
        height: 35px;
        border-radius: 21px;
        display: inline-block;
        position: absolute;
        left: -4px;
        top: -4px;
      }
    `
    : ''}
`;
//# sourceMappingURL=TeamPreview.js.map